/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { cloneElement, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import colors from '~/constants/colors';
import { useDirection } from '~/hooks/i18nHooks';

interface FloatLabelProps {
  label?: string;
  value?: any;
  onChange?: (...args: any[]) => void;
  children?: JSX.Element;
  optional?: boolean;
  required?: boolean;
  disabled?: boolean;
  [x: string]: any;
}

const FloatLabel: FC<FloatLabelProps> = (props) => {
  const { label, children, value, required, shouldUpdate, disabled, optional, ...rest } = props;
  const [focus, setFocus] = useState(false);
  const { t } = useTranslation();
  const dir = useDirection();

  const childProps =
    disabled === undefined ? { value, required, ...rest } : { value, required, disabled, ...rest };

  if (!label) {
    return children ? cloneElement(children, childProps) : null;
  }
  const labelResult = optional ? t('{{label}} (optional)', { label }) : label;
  let { placeholder } = rest;
  if (!placeholder) placeholder = labelResult;

  const isOccupied = focus || (value && value.length !== 0) || value === 0;

  return (
    <Container
      className="FloatLabel"
      isOccupied={isOccupied}
      onBlur={() => setFocus(false)}
      onFocus={() => setFocus(true)}
      dir={dir}
    >
      {children ? cloneElement(children, childProps) : null}
      <label>
        {isOccupied ? labelResult : placeholder} {required ? <span>*</span> : null}
      </label>
    </Container>
  );
};

const Container = styled.div<{ isOccupied: boolean }>`
  position: relative;
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    padding: 0 15px;
  }
  .ant-input-lg {
    padding: 10.5px 15px;
  }
  label {
    position: absolute;
    pointer-events: none;
    ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')}: 15px;
    top: 13px;
    transition: 0.2s ease all;
    border-radius: 7px;
    z-index: 1;
    color: ${colors.grey[600]};
    ${({ isOccupied, dir }) =>
      isOccupied
        ? css`
            top: -9px;
            ${dir === 'rtl' ? 'right' : 'left'}: 12px;
            font-size: 12px !important;
            background: ${colors.componentBackground};
            padding: 0 8px;
            margin-left: -4px;
          `
        : css``}
  }
`;

export default FloatLabel;
